// extracted by mini-css-extract-plugin
export var copyWrapper = "richText-module--copyWrapper--IHkHd";
export var copyWrapperConstrained = "richText-module--copyWrapperConstrained--RHWoa";